export default __webpack_public_path__ + "static/media/interior3.4529edbf.webp";